import Dialog from "../../../../../components/dialogs/Dialog";
import DialogContent from "../../../../../components/dialogs/DialogContent";
import DialogTitle from "../../../../../components/dialogs/DialogTitle";
import Grid from "../../../../../components/dialogs/Grid";
import {Stack} from "@mui/material";
import ConnectableConceptInfoPanel from "./ConnectableConceptDetailPanel";
import {RelationshipDto} from "../../../../../common/apis/relationship/RelationshipDto";
import PropertiesPanel, {PropertyApi} from "../../property/PropertiesPanel";
import {PersistentStateId} from "../../../../../store/common/Grid";
import TextField from "../../../../../components/fields/textfield/TextField";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import React, {useContext} from "react";
import {ArchimateRelationship} from "../../../../../common/archimate/ArchimateRelationship";
import SectionHeader from "../../../../../components/SectionHeader";
import {RelationshipsTranslationKey} from "../RelationshipsTranslationKey";
import {PropertiesTranslationKey} from "../../property/PropertiesTranslationKey";
import {RelationshipPropertyWrapperApi} from "./RelationshipPropertyWrapperApi";
import ElementPropertyDefinitionContext from "../../../../../common/ElementPropertyDefinitionContext";


export interface RelationshipDetailDialogProps {
    open: boolean;
    onClose: () => void;
    relationship: RelationshipDto;
}

export default function RelationshipDetailDialog(props: Readonly<RelationshipDetailDialogProps>) {
    const {open, onClose, relationship} = props;

    const propertyDefinitionContext = useContext(ElementPropertyDefinitionContext);

    const propertyClientApi: PropertyApi = React.useMemo(() => {
        return new RelationshipPropertyWrapperApi(relationship.identifier, propertyDefinitionContext);
    }, [relationship.identifier, propertyDefinitionContext]);

    return (
        <Dialog open={open}
                onClose={onClose}
                maxWidth={"lg"} >
            <DialogTitle title={_transl(RelationshipsTranslationKey.RELATIONSHIP_DETAIL)} onDialogClosed={onClose}/>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                        <TextField label={_transl(RelationshipsTranslationKey.TYPE)}
                                   value={ArchimateRelationship.findByStandardName(relationship.type)?.visibleName ?? relationship.type}
                                   InputProps={{
                                       readOnly: true,
                                   }} />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <TextField label={_transl(RelationshipsTranslationKey.NAME)}
                                   value={relationship.name ?? ""}
                                   InputProps={{
                                       readOnly: true,
                                   }} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <ConnectableConceptInfoPanel title={_transl(RelationshipsTranslationKey.SOURCE)}
                                connectableConcept={relationship.source}/>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <ConnectableConceptInfoPanel title={_transl(RelationshipsTranslationKey.TARGET)}
                                connectableConcept={relationship.target}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack spacing={2} mt={0}>
                            <SectionHeader>{_transl(PropertiesTranslationKey.PROPERTIES)}</SectionHeader>
                            <PropertiesPanel
                                    canUpdateProperties={relationship.acl.canUpdate}
                                    propertyApi={propertyClientApi}
                                    persistentStateId={PersistentStateId.RELATIONSHIP_DETAIL_PROPERTIES_GRID}
                                    resourceId={relationship.identifier} />
                        </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}